const STORAGE_KEY = "logimind.reportPeriod";

const GRAINS = new Set(["daily", "weekly", "monthly", "quarterly", "yearly"]);

function isYear(value) {
  return Number.isInteger(value) && value >= 1 && value <= 9999;
}

function isMonth(value) {
  return Number.isInteger(value) && value >= 1 && value <= 12;
}

function isDay(value) {
  return Number.isInteger(value) && value >= 1 && value <= 31;
}

/**
 * Year and month chosen in the report filter.
 * Kept for the browser session so route changes and other reports do not reset it.
 */
export function readReportPeriod(fallback) {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    const year = Number(parsed?.year);
    const month = Number(parsed?.month);
    if (!isYear(year) || !isMonth(month)) return fallback;
    const day = Number(parsed?.day);
    const asOf = Number(parsed?.as_of_day);
    return {
      ...fallback,
      year,
      month,
      period: GRAINS.has(parsed?.period) ? parsed.period : fallback?.period || "monthly",
      day: isDay(day) ? day : fallback?.day,
      ...(isDay(asOf) ? { as_of_day: asOf } : {}),
    };
  } catch {
    return fallback;
  }
}

export function writeReportPeriod(period) {
  if (!period) return;
  const year = Number(period.year);
  const month = Number(period.month);
  if (!isYear(year) || !isMonth(month)) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        year,
        month,
        period: GRAINS.has(period.period) ? period.period : "monthly",
        day: period.day,
        as_of_day: period.as_of_day,
      }),
    );
  } catch {
    /* private mode / quota */
  }
}
